import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

export class Supplier {
  id: string;
  name: string;
  taxNumber: string;
  taxOffice: string;
  phoneNumber: string;
  contactPerson: string;
  createdAt: Date;
  supplierType: string;
}

export class ISupplierResponse {
  @Type(() => Supplier)
  result: Supplier;
}

export class ISupplierListResponse extends IPagination {
  @Type(() => Supplier)
  results: Supplier[];
}

export class ISupplierQueryDto extends IQueryPaginationDto {
  name?: string;
  supplierType?: string;
}

export class ISupplierPatchBodyDto {
  name?: string;
  taxNumber?: string;
  taxOffice?: string;
  phoneNumber?: string;
  contactPerson?: string;
  supplierType?: string;
}

export class IPostSupplierBodyDto {
  name: string;
  taxNumber: string;
  taxOffice: string;
  phoneNumber: string;
  contactPerson: string;
  supplierType: string;
}
